import React, { useEffect } from "react";
import { toast } from "react-toastify";
import Axios from "axios";

function Login() {
  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      // ลบ item ทั้งหมดใน localStorage
      localStorage.clear();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const username = document.getElementById("login_username").value;
      const password = document.getElementById("login_password").value;

      if (!username || !password) {
        toast.error("กรุณากรอกชื่อผู้ใช้และรหัสผ่าน");
        return;
      }

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/login`,
        {
          username,
          password,
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      const { status, message, token } = response.data;

      if (status === "OK") {
        const authenResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/authen`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              key: process.env.REACT_APP_ANALYTICS_KEY,
            },
          }
        );

        const authenStatus = authenResponse.data.status;
        const authenData = authenResponse.data.decoded;
        console.debug("authenData:", authenData);
        if (authenStatus === "OK") {
          localStorage.setItem("token", token);
          localStorage.setItem("emp_id", authenData.Emp_Id);
          localStorage.setItem("name", authenData.Emp_Name);
          localStorage.setItem("company", authenData.Comp_Id);
          localStorage.setItem("WHID", authenData.WH_ID);
          localStorage.setItem("EmpPosition", authenData.Emp_Position);
          window.location.replace("/billofsale");
        } else {
          localStorage.clear();
          toast.error(message);
        }
      } else {
        localStorage.clear();
        toast.error(message);
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error(error.message);
    }
  };

  return (
    <div className="Login" style={{ height: "100vh" }}>
      <div className="container d-flex align-items-center justify-content-center h-100">
        <div className="col-lg-4 col-md-6 col-sm-8">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-5">
              <div className="text-center mb-4">
                <img
                  src="assets/img/logo_login.png"
                  alt="logo_login"
                  className="navbar-brand mb-3"
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: "16px 0px 0px 0px",
                    border: "1px solid transparent",
                  }}
                />
                <h3 style={{ color: "#EF6C00" }}>Sign-in to System you</h3>
              </div>
              <form className="user" onSubmit={handleLogin}>
                <div className="form-group text-start">
                  <label htmlFor="login_username">Username</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="fa fa-user" />
                    </span>
                    <input
                      className="form-control form-control-lg"
                      id="login_username"
                      type="text"
                      name="login_username"
                      placeholder="Username"
                    />
                  </div>
                </div>
                <div className="form-group text-start">
                  <label htmlFor="login_password">Password</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="fa fa-lock" />
                    </span>
                    <input
                      className="form-control form-control-lg"
                      id="login_password"
                      type="password"
                      name="login_password"
                      placeholder="Password"
                    />
                  </div>
                </div>
                <div className="form-group text-start mb-4">
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input" />
                    <label className="form-check-label">
                      Keep me logged in
                    </label>
                  </div>
                </div>
                <button
                  type="submit"
                  style={{ backgroundColor: "#EF6C00" }}
                  className="btn btn-lg w-100 shadow text-white"
                >
                  Login
                </button>
                <div className="text-center mt-4">
                  <button
                    type="button"
                    style={{
                      color: "#EF6C00",
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      // รอทำ
                    }}
                    className="text-decoration-underline"
                  >
                    Forgot Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
